import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import { deleteVehicle } from "../../services/vehicleService";
import SuccessMessageModal from "../Reusable/SuccessMessageModal";
import WarningMessageModal from "../Reusable/WarningMessageModal";

const DeleteVehiculoModal = ({ isOpen, onClose, vehiculo }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [isWarningOpen, setIsWarningOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await deleteVehicle(vehiculo.vehicle_id);
      setModalMessage("Vehículo eliminado exitosamente.");
      setIsSuccessOpen(true);
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Error al eliminar el vehículo.";
      setModalMessage(errorMessage);
      setIsWarningOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSuccessClose = () => {
    setIsSuccessOpen(false);
    onClose(true); // Indicar que se debe refrescar
  };

  return (
    <Dialog open={isOpen} onClose={() => onClose(false)}>
      <DialogTitle>Eliminar Vehículo</DialogTitle>
      <DialogContent>
        {isLoading ? (
          <Box display="flex" justifyContent="center"><CircularProgress /></Box>
        ) : (
          <Typography>
            ¿Estás seguro de que deseas eliminar el vehículo con placa{" "}
            <strong>{vehiculo ? vehiculo.plate : ""}</strong>?
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)}>Cancelar</Button>
        <Button onClick={handleConfirm} color="error" variant="contained" disabled={isLoading}>
          Eliminar
        </Button>
      </DialogActions>
      <SuccessMessageModal isOpen={isSuccessOpen} message={modalMessage} onClose={handleSuccessClose} />
      <WarningMessageModal isOpen={isWarningOpen} message={modalMessage} onClose={() => setIsWarningOpen(false)} />
    </Dialog>
  );
};

export default DeleteVehiculoModal;
